export default "__VITE_ASSET__DBuqT8R8__"